import { isGoogleAddressType, naiveAttemptGeocodeAsync, tryParseJSONObject } from '@fox/atoms';
import { IQuestionAnswer } from '../../../form-root/contracts';

export const ensureAnswers = async (a: IQuestionAnswer[], region: string) => {
	// loop through answer, see if need to handle custom addresses and/or rsvp's and merge the single CreatePerson block
	for (const element of a) {
		//if we are ever going to include update again, we will need to probably have an update person block?
		if ((element?.answer?.answerJson && element.type === 'CreatePerson') || element.type === 'CreatePersons') {
			let parsed = tryParseJSONObject(element?.answer?.answerJson);
			if (parsed) {
				//we need to check if 'contacts' array is present
				//if not then perhaps it is an old style config, not 100% sure this is needed but it cant hurt
				//in that case we need to add the contacts array and chuck all values in there
				if (!Object.keys(parsed).includes('contacts')) {
					parsed = {
						contacts: [{ ...parsed }]
					};
				}
				//here we need to make sure each contact has the exact same keys, otherwise this will break down the line in core-backend
				var uniqueContactKeys = Object.keys(
					parsed.contacts.reduce(function (result, obj) {
						return Object.assign(result, obj);
					}, {})
				);
				for (let contact of parsed.contacts) {
					uniqueContactKeys.forEach(key => {
						if (!contact.hasOwnProperty(key)) {
							contact[key] = undefined;
						}
					});
					for (const el of Object.keys(contact)) {
						if (el.includes('Address') || el.startsWith('businessAddress:')) {
							const addr = JSON.parse(contact[el]);
							// the GoogleAddressType comes from searching and already has geo code
							if (!isGoogleAddressType(addr)) {
								// geo code the custom address
								const newAddrObj = await naiveAttemptGeocodeAsync(addr, region);
								contact[el] = newAddrObj;
							}
						}
					}
				}
			}
			// turn into JSON again
			const stringified = JSON.stringify(parsed);
			// change the answer to the modified answer (w geocode)
			element['answer'] = { ...(element?.answer ?? {}), answerJson: stringified };
		}
	}

	return a;
};
